import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import Sidebar from './Sidebar';
import styles from './Layout.module.css';

// Layout adapts to viewport:
//   ≥ 900px → fixed sidebar always visible (with optional collapsed state)
//   < 900px → sidebar hidden by default, slides in as a drawer when toggled.
const MOBILE_BREAKPOINT = 900;

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Track viewport width.
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Close mobile drawer on route change.
  useEffect(() => {
    if (isMobile) setDrawerOpen(false);
  }, [location.pathname, isMobile]);

  // Lock body scroll when drawer is open on mobile.
  useEffect(() => {
    if (isMobile && drawerOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
    return undefined;
  }, [isMobile, drawerOpen]);

  const layoutClass = `${styles.layout} ${isMobile ? styles.mobile : ''}`;
  const mainClass = `${styles.main} ${
    !isMobile && sidebarCollapsed ? styles.expanded : ''
  } ${isMobile ? styles.mainMobile : ''}`;

  return (
    <div className={layoutClass}>
      {isMobile && (
        <header className={styles.mobileHeader}>
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
          >
            <FiMenu />
          </button>
          <div className={styles.mobileLogo}>
            <img src="/dierend-logo.png" alt="Dierend" />
            <span>Dierend Admin</span>
          </div>
        </header>
      )}

      {isMobile && drawerOpen && (
        <button
          type="button"
          className={styles.backdrop}
          onClick={() => setDrawerOpen(false)}
          aria-label="Close menu"
        />
      )}

      <Sidebar
        collapsed={!isMobile && sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((c) => !c)}
        isMobile={isMobile}
        drawerOpen={drawerOpen}
        onCloseDrawer={() => setDrawerOpen(false)}
      />

      <main className={mainClass}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
